import {useContext, useEffect, useState} from "react";
import {CompanyContext} from "../../lib/CompanyContext";

export default function SwitchLocation() {
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [orgMode, setOrgMode] = useState(false);
  const [orgChart, setOrgChart] = useState(null);
  useEffect(() => {
    setOrgMode(companyContext?.company?.orgChart?.orgOwner || false);
  }, [companyContext?.company]);

  return (
    <>
      <div style={{
        width: '120px',
        overflow: 'hidden',
        paddingTop: orgMode ? '5px' : '12px',
        height:'40px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        lineHeight:'1.125rem',
      }}>
        {orgMode && <>
          Current Location:<br/>
          <small><strong>{companyContext?.company?.companyName}</strong></small>
        </>}
      </div>
    </>
  )
}